
import { defineComponent, getCurrentInstance, SetupContext, ref, watch, onMounted } from 'vue';
import ActionSheet from 'vant/lib/action-sheet';
import Loading from '../loading-dark/index.vue';
import { roundingNum, replaceRoutePhotoId } from '@/common/utils';
import { FeedApiService, UserComment } from '@/api/feed';
import { getTemplateConfig } from './template.config';

function formatDateDiffToNow(millisecondsTimestamp: number) {
    const inputDate = new Date(millisecondsTimestamp) as any; // 使用毫秒级别的时间戳
    const now = new Date() as any;
    const diffMilliseconds = now - inputDate;
    const diffSeconds = Math.floor(diffMilliseconds / 1000);
    const diffMinutes = Math.floor(diffSeconds / 60);
    const diffHours = Math.floor(diffMinutes / 60);
    const diffDays = Math.floor(diffHours / 24);
    if (diffSeconds < 60) {
        return 'Just now';
    }
    if (diffMinutes < 60) {
        return `${diffMinutes}m ago`;
    }
    if (diffHours < 24) {
        return `${diffHours}h ago`;
    }
    if (diffDays < 7) {
        if (now.getFullYear() === inputDate.getFullYear()) {
            return `${diffDays}d ago`;
        }
    } else if (diffDays < 365) {
        return inputDate.toLocaleDateString(undefined, { month: '2-digit', day: '2-digit' }).replaceAll('/', '-');
    } else {
        return inputDate
            .toLocaleDateString({
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            })
            .replaceAll('/', '-');
    }
}

const CommentList = defineComponent({
    components: {
        VanActionSheet: ActionSheet,
        Loading,
    },
    props: {
        show: Boolean,
        photoId: {
            type: String,
            default: () => '',
        },
    },
    setup(props, ctx: SetupContext<Array<'onClose'>>) {
        const { proxy } = getCurrentInstance() || {};
        const FeedApi = new FeedApiService();

        const isLoading = ref(true);
        const commentList = ref<UserComment[]>([]);

        const handleClose = () => {
            // eslint-disable-next-line vue/require-explicit-emits
            ctx.emit('onClose');
        };

        const handleViewUser = async (params: Record<string, any>) => {
            console.log('params', params);
            replaceRoutePhotoId(proxy).finally(() => {
                proxy?.$router?.push?.({ path: `/@${params.kwaiid}` });
            });
        };

        const fetchCommentList = async (photoId?: string) => {
            if (!photoId) {
                return [];
            }
            isLoading.value = true;
            const res = await FeedApi.getUserCommentList({
                photo_id: photoId,
            });
            isLoading.value = false;

            return res?.comments || [];
        };

        watch(
            () => props.photoId,
            async newPhotoId => {
                const list = await fetchCommentList(newPhotoId);
                commentList.value = list;
            }
        );

        onMounted(async () => {
            const list = await fetchCommentList(props.photoId);
            commentList.value = list;
        });

        return {
            isLoading,
            commentList,

            handleClose,
            roundingNum,
            handleViewUser,
            formatDateDiffToNow,

            templateConfig: getTemplateConfig(),
        };
    },
});

export default CommentList;
